// @core/api/endpoints/product/create_product.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateProductRequest,
  ProductResponse,
} from '../../../types/product';

const BASE_PATH = '/product';

/**
 * Register a new product
 * Registers a new product in the platform. The product is created in draft status and must be published to appear in the catalog.
 */
export async function CreateProduct(
  data: CreateProductRequest,
  options?: RequestOptions
): Promise<ProductResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/products`;
  const requestOptions = options;
  return client.post<ProductResponse>(requestPath, data, requestOptions);
}
